import { Route } from "react-router-dom";
import { CreateRFI, CreateRFIFromProject, EditRFI } from "../RFIs/RFI";
import ViewRFI, { UsersRFIList } from "../RFIs/Table/RFIList";

export const RFI_ROUTES = [
    <Route key="rfi" path="/rfis" element={<ViewRFI />} />,
    <Route key="rfi-create" path="/rfis/create_rfi" element={<CreateRFI />} />,
    <Route key="rfi-create-from-project" path="/rfi/create_rfi_from_project/:id" element={<CreateRFIFromProject />} />,
    <Route key="rfi-update" path="/rfis/update_rfi/:id" element={<EditRFI />} />,
    <Route key="rfi-personal" path="/rfis/personal" element={<UsersRFIList />} />
];
